import { AlertDialog, AlertDialogHeader, AlertDialogOverlay, AlertDialogContent, AlertDialogBody, AlertDialogFooter, Button } from "@chakra-ui/react";
import { useTeamMembers } from "lib/hooks";
import { DangerIcon } from "lib/icons/danger";
import { FC, useRef } from "react";
import { useTeamUserActionContext } from "./teamUserActionProvider";

type Props = {
  isOpen: boolean;
  onClose: any;
}

export const RemoveTeamUserAlertDialog: FC<Props> = ({onClose, isOpen}) => {
  const cancelRef = useRef();
  const { teamUser } = useTeamUserActionContext();
  const { deleteTeamMember } = useTeamMembers();

  const handleDelete = async () => {
    await deleteTeamMember(teamUser.user.id);
    onClose();
  }

  return (
    <AlertDialog
      motionPreset="slideInBottom"
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isOpen={isOpen}
      isCentered
    >
      <AlertDialogOverlay />
      <AlertDialogContent className="dialog__content">
        <AlertDialogHeader className="dialog-delete__header">
          <DangerIcon width="22px" height="22px"/>
          Are you sure you want to remove this user from your team’s account?
        </AlertDialogHeader>
        <AlertDialogBody className="dialog-delete__content">
          All packs and assets that this user created under this team will be deleted and cannot be recovered.
        </AlertDialogBody>
        <AlertDialogFooter className="dialog-delete__footer">
          <Button variant="cancel" ref={cancelRef} onClick={onClose}>Cancel</Button>
          <Button variant="destructive" onClick={handleDelete}>Remove</Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
};
